<template>
  <v-select
    :value="value"
    :items="options"
    :label="label"
    :disabled="disabled"
    :error-messages="errorMessages"
    :loading="loading"
    item-text="name"
    item-value="id"
    no-data-text="Партнёров этого типа нет"
    clearable outlined dense
    @input="$emit('input', $event === undefined ? null : $event)"
  />
</template>

<script>
import { partnerFullName, isPartnerOfType } from '@/common/models/partnerTypes';

// Выбор партнёра одного типа (супервизор или реферал) для корп. клиента. Очистка отдаёт null: бэк снимает привязку.
export default {
  name: 'CorpPartnerSelect',
  props: {
    value: { type: [Number, String], default: null },
    partners: { type: Array, default: () => [] },
    type: { type: String, required: true },
    label: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    errorMessages: { type: Array, default: () => [] },
  },
  computed: {
    options() {
      return this.partners
        .filter((p) => isPartnerOfType(p, this.type) || String(p.id) === String(this.value))
        .map((p) => ({ id: p.id, name: partnerFullName(p) }));
    },
  },
};
</script>
